export function setOrders (state, orders) {
  state.orders = orders
}

export function addOrders (state, orders) {
  state.orders.orders.push(...orders.orders)
  state.orders.self = orders.self
  state.orders.next = orders.next
}

export function setOrder (state, order) {
  state._order = order
}
